import { render, staticRenderFns } from "./AccidentLogTable.vue?vue&type=template&id=5ac838fd&scoped=true&"
import script from "./AccidentLogTable.vue?vue&type=script&lang=js&"
export * from "./AccidentLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac838fd",
  null
  
)

export default component.exports